import * as React from "react";

export const IconResend = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.75 5C13.8917 5 14.0333 5.00833 14.1667 5.025V1.55833C14.1667 0.7 13.4667 0 12.6083 0L1.55833 0C0.7 0 0 0.7 0 1.55833L0 10.1083C0 10.9667 0.7 11.6667 1.55833 11.6667L9.66667 11.6667C9.35 11.0417 9.16667 10.3333 9.16667 9.58333C9.16667 7.05 11.2167 5 13.75 5ZM7 6.66667L1.66667 3.49167L1.66667 1.66667H1.85833L7.00833 4.73333L12.2833 1.66667H12.5V3.46667L7 6.66667Z"
      fill="white"
    />
    <path
      d="M14.1654 6.6665L12.9904 7.8415L14.307 9.1665H10.832V10.8332H14.307L12.9904 12.1582L14.1654 13.3332L17.4987 9.99984L14.1654 6.6665Z"
      fill="white"
    />
  </svg>
);
